module.exports = __webpack_public_path__ + "img/img_certification_mark_04.fe45213.png";